export default {"svg":"svg-icon-module__svg___-Lfvi","default-color":"svg-icon-module__default-color___G0yU4","inherit-color":"svg-icon-module__inherit-color___wGE8i"}
import '/home/jenkins/agent/workspace/elease_release_common-icons_5.12/packages/common/icons/src/components/svg-icon.module.css'
